export default {
  sm: `
  Janggyeonggak is a "zero-energy"
  building that has been preserving Tripitaka
  Koreana with only the innate properties of
  the building materials and its environment.
  The wisdom of our ancestors using natural
  energy has greatly inspired us on our
  intention to go green for DATA CENTER GAK.
  `,
  lg: `
  Janggyeonggak is a "zero-energy" building
  that has been preserving Tripitaka Koreana with
  only the innate properties of the building materials
  and its environment. The wisdom of our ancestors
  using natural energy has greatly inspired us on our
  intention to go green for DATA CENTER GAK.
  `,
  xxl: `
  Janggyeonggak is a "zero-energy" building that has been preserving
  Tripitaka Koreana with only the innate properties of the building
  materials and its environment. The wisdom of our ancestors using
  natural energy has greatly inspired us on our intention to go green
  for DATA CENTER GAK.
  `,
};
